<template>
  <div>
    <SearchResultsTopSkeleton v-show="showSkeletonLoader" />
    <div
      v-show="!showSkeletonLoader"
      class="search-results__top mt-4 mb-2 lg:mb-12"
      :class="{'flex-wrap items-center': isCampaignAvaliable}"
    >
      <div
        v-if="isCampaignAvaliable"
        class="basis-full grow block w-full lg:w-1/2 lg:basis-auto"
      >
        <RenderContent
          :content="campaignBanner"
          class="h-36 lg:h-48"
        />
      </div>
      <div
        :class="{
          'order-last lg:order-first': categoryFilter,
          'lg:order-first': isCampaignAvaliable
        }"
        class="search-results__reminder grow lg:grow-0 px-4 lg:px-0"
      >
        <div
          v-if="isCampaignAvaliable"
          class="lg:max-w-sm"
        >
          <RenderContent
            :content="campaignTitle"
          />
        </div>
        <p
          v-if="description"
          class="text-left"
        >
          {{ description }}
        </p>
        <ais-stats
v-if="!categoryFilter && isOnSearchPage"
v-slot="{ nbHits }">
<p
            v-if="isCampaignAvaliable"

            class="lg:text-left"
          >
            {{ $t('product-count', { productCount: nbHits }) }}
          </p>
          <p
            v-else
          >
            <span>{{ $t('Number of Search Results', nbHits, { count: nbHits }) }}</span>
            <span
              v-if="query"
              class="font-bold"
            >
              {{ $t('Search Term:') }} {{ query }}
            </span>
          </p>
</ais-stats>
        <CategoryBreadcrumbs v-else />
      </div>
      <div
        v-if="hits.length > 0"
        class="search-results__toolboxes w-full lg:w-1/2 items-center leading-7 px-4"
        :class="{'lg:w-auto lg:order-last lg:px-0': isCampaignAvaliable}"
      >
        <div class="pr-2.5 w-1/2 lg:hidden">
          <button
            class="search-results__filter-toolbox--mobile border font-semibold w-full"
            @click="onFilterClick"
          >
            <ais-stats v-slot="{ instantSearchInstance }">
<span>
                {{ $t("Filter") }} ({{
                  getCurrentFiltersCount(instantSearchInstance.indexName, instantSearchInstance.renderState)
                }})
              </span>
</ais-stats>
          </button>
        </div>
        <div
          class="flex w-1/2 lg:w-auto"
          data-testid="sortingSelect"
        >
          <span class="hidden lg:inline text-rights self-center whitespace-nowrap">
            {{ $t("Sort by") }}:
          </span>
          <ais-sort-by
            class="pl-2.5 w-full"
            :items="sortingConfig"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">

import {
  AisStats,
  AisSortBy,
} from 'vue-instantsearch/vue3/es';
import { TYPESENSE_LOADING_STATE, TYPESENSE_STALLED_STATE } from '~~/constants/typesense';
import { getCurrentFiltersCount } from '~~/helpers/typesense/getCurrentFiltersCount/getCurrentFiltersCount';
import { getTypesenseSortingConfiguration } from '~~/helpers/typesense/getTypesenseSortingConfiguration';

export default defineComponent({
  name: 'SearchResultsInner',
  components: {

    AisStats,

    AisSortBy,
  },
  props: {
    categoryFilter: {
      type: String,
      default: '',
    },
    hits: {
      type: Array,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
  setup(props) {

    const i18n = useI18n();
    const { toggleFilterModal } = useUiState();

    const { isOnSearchPage } = useIsPage();

    const showSkeletonLoader = computed(() => {

      const isPending = props.status === TYPESENSE_STALLED_STATE || props.status === TYPESENSE_LOADING_STATE;

      return isPending && props.hits.length === 0;

    });

    const {
      showCampaignInfo,
      campaignData,
    } = useDisplayCampaignInfo();

    const campaignBanner = computed(() => campaignData.value?.banner || null);
    const campaignTitle = computed(() => campaignData.value?.title || null);

    const isCampaignAvaliable = computed(() => showCampaignInfo.value && campaignBanner.value && campaignTitle.value);

    const onFilterClick = () => {

      toggleFilterModal();

    };

    const rawSortingConfig = computed(() => getTypesenseSortingConfiguration(i18n));
    const translatedSortingConfig = computed(() => rawSortingConfig.value.map((sortingOption) => ({
      ...sortingOption,
      label: typeof i18n?.t === 'function' ? String(i18n.t(sortingOption.label)) : sortingOption.label,
    })));

    return {
      campaignData,
      sortingConfig: translatedSortingConfig,
      onFilterClick,
      getCurrentFiltersCount,
      showSkeletonLoader,
      isCampaignAvaliable,
      campaignBanner,
      campaignTitle,
      isOnSearchPage,
    };

  },
});

</script>

<style lang="scss" scoped>
@use "~/assets/scss/helpers/_breakpoints" as breakpoints;
  @use "~/assets/scss/typesense/_ais-SortBy" as ais-SortBy;

  .search-results__top {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: var(--spacer-base);

    .search-results__reminder {
      text-align: center;
    }

    .search-results__toolboxes {
      display: flex;
      justify-content: flex-end;
    }

    .search-results__filter-toolbox--mobile {
      text-align: center;
      padding: 0.3rem 0;
      border-radius: var(--buttons-border-radius);
    }

    @include breakpoints.for-desktop {
      flex-direction: row;
    }
  }
</style>
